import React, { Component } from 'react'
import { Statistic, Icon, Grid, Container, Image, Segment, Dimmer, Loader } from 'semantic-ui-react'
import { movieApi } from '../../api/MovieApi'
import { handleLogError } from '../../utils/Logger'

class Home extends Component {
  state = {
    numberOfUsers: 0,
    isLoading: false
  }

  async componentDidMount() {
   // console.log("Home page")
    this.setState({ isLoading: true })
    try {
      let response = await movieApi.numberOfUsers()
      const numberOfUsers = response.data

      this.setState({ numberOfUsers })
    } catch (error) {
      handleLogError(error)
    } finally {
      this.setState({ isLoading: false })
    }
  }

  render() {
    const { isLoading } = this.state
    if (isLoading) {
      return (
        <Segment basic style={{ marginTop: window.innerHeight / 2 }}>
          <Dimmer active inverted>
            <Loader inverted size='huge'>Loading</Loader>
          </Dimmer>
        </Segment>
      )
    } else {
      const { numberOfUsers } = this.state
      return (
        <Container text>
          <Grid stackable columns={1}>
            <Grid.Row>
              <Grid.Column textAlign='center'>
                <Segment color='purple'>
                  <Statistic>
                    <Statistic.Value><Icon name='user' color='grey' />{numberOfUsers}</Statistic.Value>
                    <Statistic.Label>Users</Statistic.Label>
                    <Statistic.Label>Users</Statistic.Label>
                  </Statistic>
                </Segment>
              </Grid.Column>
            </Grid.Row>
          </Grid>

          <Image src='https://react.semantic-ui.com/images/wireframe/media-paragraph.png' style={{ marginTop: '2em' }} />
          <Image src='https://react.semantic-ui.com/images/wireframe/paragraph.png' style={{ marginTop: '2em' }} />
        </Container>
      )
    }
  }
}

export default Home